/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Enable_TitleInputs */



/**
* | output |
* | --- |
* | "Enable billing" |
*
* @param {Partner_Admin_Billing_Enable_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_enable_title = /** @type {((inputs?: Partner_Admin_Billing_Enable_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Enable_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abrechnung aktivieren")
	return /** @type {LocalizedString} */ ("Enable billing")
});